export const formatAddress = (parts: (string | null | undefined)[]): string => parts.filter(Boolean).join(', ')
